import styled from "styled-components";

export const Container = styled.div`
  background-color: ${(props) => props.theme.colors.white};
  font-family: ${(props) => props.theme.fontFamilies.primaryFont};
  align-items: center;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  max-height: 80vh;
  overflow-y: scroll;
  padding: 5rem 7rem;
  scrollbar-width: none;
  width: 70rem;

  -ms-overflow-style: none;
  ::-webkit-scrollbar {
    display: none;
  }

  h1 {
    ${(props) => `
      color: ${props.theme.colors.blackTextBody};
    `}
    font-size: 2rem;
    font-weight: 800;
    margin-bottom: 3rem;
    margin-top: 0;
  }
`;

export const MainButton = styled.button`
  ${(props) => `
    background-color: ${props.theme.colors.accentGreen};
    color: ${props.theme.colors.white};
    font-family: ${props.theme.fontFamilies.primaryFont};
  `}
  align-items: center;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  display: flex;
  font-size: 1.7rem;
  font-weight: 700;
  justify-content: center;
  margin-top: 4rem;
  min-height: 5.8rem;
  width: 30rem;

  &:disabled,
  &[disabled] {
    background-color: ${(props) =>
      props.theme.colors.accentGreen + props.theme.transparencies.p20};
    cursor: not-allowed;
  }

  .icon {
    height: 5rem;
    width: 5rem;
  }
`;
